ThankYouController.$inject = [
  'ApplicationService',
  '$scope',
  '$sce'
];

function ThankYouController (ApplicationService, $scope, $sce) {
  var data = ApplicationService.getData();
  $scope.previouslyAppointed = data.previouslyAppointed;
  $scope.selectedStates = data.selectedStates;
  $scope.currentSite = ApplicationService.getCurrentSite();
  $scope.pdfUrl = ApplicationService.getPdfUrl();
  $scope.trustSrc = function (src) {
    return $sce.trustAsResourceUrl(src);
  };
}

export default ThankYouController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/ThankYouController.js
// module id = 25
// module chunks = 0